<template>
  <div>
    <div v-if="learningUnit" class="h5 display-4 mt-1 mb-5 font-weight-bold">
      {{ learningUnit.name }}
    </div>
    <BaseFormSection :learning-unit="learningUnit"></BaseFormSection>
  </div>
</template>

<script>
import BaseFormSection from './BaseFormSection';
import { sectionMixin } from '@/mixins';

export default {
  components: {
    BaseFormSection
  },

  mixins: [sectionMixin],

  async mounted() {
    await this.fetchLearningUnit();
  }
};
</script>
